import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import SaleForm from "@/components/sales/SaleForm";
import MultiApartmentSaleForm from "@/components/sales/MultiApartmentSaleForm";
import PaymentForm from "@/components/payments/PaymentForm";
import { useSalesAndPayments } from "@/context/SalesAndPaymentsContext";

export default function SalesDialogs() {
  const ctx = useSalesAndPayments();
  const {
    showSaleForm,
    setShowSaleForm,
    editingSale,
    setEditingSale,
    showPaymentForm,
    setShowPaymentForm,
    editingPayment,
    setEditingPayment,
    clients,
    apartments,
    sales,
    handleSaleSubmit,
    handlePaymentSubmit,
    createSaleMutation,
    updateSaleMutation,
    createPaymentMutation,
    updatePaymentMutation,
  } = ctx;

  return (
    <>
      <Dialog open={showSaleForm} onOpenChange={setShowSaleForm}>
        <DialogContent className="max-w-5xl max-h-[90vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle>
              {editingSale ? "Edit Sale" : "Create New Sale"}
            </DialogTitle>
          </DialogHeader>
          {editingSale ? (
            <SaleForm
              key={editingSale.id}
              sale={editingSale}
              clients={clients}
              apartments={apartments.filter(
                (a) => a.status === "available" || a.id === editingSale.apartment_id
              )}
              onSubmit={handleSaleSubmit}
              onCancel={() => {
                setShowSaleForm(false);
                setEditingSale(null);
              }}
              isLoading={
                createSaleMutation.isPending || updateSaleMutation.isPending
              }
            />
          ) : (
            <MultiApartmentSaleForm
              clients={clients}
              apartments={apartments.filter((a) => a.status === "available")}
              onSubmit={handleSaleSubmit}
              onCancel={() => {
                setShowSaleForm(false);
                setEditingSale(null);
              }}
              isLoading={createSaleMutation.isPending}
            />
          )}
        </DialogContent>
      </Dialog>
      <Dialog open={showPaymentForm} onOpenChange={setShowPaymentForm}>
        <DialogContent className="max-w-3xl max-h-[90vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle>
              {editingPayment ? "Edit Payment" : "Record New Payment"}
            </DialogTitle>
          </DialogHeader>
          <PaymentForm
            key={editingPayment?.id ?? "new"}
            payment={editingPayment}
            sales={sales}
            clients={clients}
            apartments={apartments}
            onSubmit={handlePaymentSubmit}
            onCancel={() => {
              setShowPaymentForm(false);
              setEditingPayment(null);
            }}
            isLoading={
              createPaymentMutation.isPending || updatePaymentMutation.isPending
            }
          />
        </DialogContent>
      </Dialog>
    </>
  );
}